module.exports = "<sx-listado-desplegable [fuente]=\"grupos\" [tipo]=\"'OUTPUT' | translate\">\r\n</sx-listado-desplegable>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/output/configurar.output.component.html
// module id = ../../../../../src/app/private/configuracion/output/configurar.output.component.html
// module chunks = main